import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b390818"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "level-item has-text-centered" }
const _hoisted_2 = { class: "req-visibility-banner-row m-top-8 m-bottom-8 is-size-5" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "has-text-weight-semibold" }, "Request visibility:", -1))
const _hoisted_5 = {
  key: 1,
  class: "has-text-weight-semibold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NrTooltip = _resolveComponent("NrTooltip")!
  const _component_NrIcon = _resolveComponent("NrIcon")!
  const _component_NrIconButton = _resolveComponent("NrIconButton")!
  const _component_NrFormSelect = _resolveComponent("NrFormSelect")!
  const _component_NrModal = _resolveComponent("NrModal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["level req-visibility-banner", $options.setBannerStyles])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$can('update', 'Request'))
          ? (_openBlock(), _createBlock(_component_NrTooltip, { key: 0 }, {
              label: _withCtx(() => [
                _createElementVNode("p", { innerHTML: $options.visibilityLabelTooltip }, null, 8, _hoisted_3)
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, "Request Visibility:")),
        _createVNode(_component_NrIcon, {
          class: "m-right-8 m-left-8",
          "aria-hidden": "true",
          name: $options.setBannerIcon
        }, null, 8, ["name"]),
        _createElementVNode("span", null, _toDisplayString($options.setBannerText), 1),
        ($props.requestVisibility && _ctx.$can('manage', 'Request'))
          ? (_openBlock(), _createBlock(_component_NrIconButton, {
              key: 2,
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.toggleEditModal(true))),
              class: "m-left-8",
              icon: { name: 'pencil-alt', type: 'regular' },
              "aria-label": "Edit request visibility",
              variant: "minimal-neutral"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_NrModal, {
      show: $data.showEditModal,
      class: "request-visibility-form",
      "has-secondary-button": true,
      title: "Change request visibility",
      "primary-button-text": "Change visibility",
      "secondary-button-text": "Cancel",
      onOnPrimaryClick: $options.updateRequestVisibility,
      onOnSecondaryClick: _cache[2] || (_cache[2] = () => $options.toggleEditModal(false)),
      onOnClose: _cache[3] || (_cache[3] = () => $options.toggleEditModal(false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NrFormSelect, {
          label: "Request visibility",
          name: "visibility",
          modelValue: _ctx.request.visibility,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.visibility) = $event)),
          options: $options.visibilities
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }, 8, ["show", "onOnPrimaryClick"])
  ], 2))
}